var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 7.5,
  x: 1.5,
  y: 4.25,
  fill: "#fff",
  stroke: "#56893E",
  strokeWidth: 1.5,
  rx: 3.25
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 7.5,
  x: 4.5,
  y: 6.5,
  fill: "#fff",
  stroke: "#56893E",
  strokeWidth: 1.5,
  rx: 3.25
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 10.25,
  r: 1.5,
  stroke: "#56893E",
  strokeWidth: 1.5
})));
export default SvgCash;